import { Injectable } from '@angular/core';
import { Menu } from '../interface/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menu: Menu[] = [];
  activeRoutes: string[] = [];
  constructor() { }

  getInventoryConfiguration(routes:string[]){
    if(this.menu.length) {
      const inventoryChild = this.menu.find(m=>m.route ==='inventory')?.child || null;
      return this.menuConfiguration(inventoryChild,routes);
    }
    return null;
  }

  private menuConfiguration(menu:Menu[]|null,routes:string[]){
    if(routes.length && menu?.length) {
      let typeId:number = 0;
      let type: string = '';
      const category: string[] = [];
      let tempMenu = structuredClone(menu);
      for (const [index , value] of routes.entries()) {
          const tMenu = tempMenu.find(m=>m.route === value);
          if(tMenu){
            if(index === 1){
              type = tMenu.route;
            }else if(index >1){
              category.push(tMenu.route);
            }
            if(tMenu.child?.length){
              tempMenu = tMenu.child;
            }else{
              typeId = tMenu.id;
              break;
            }
          }
          
      }
      return {typeId,type,category};
    }
    return null;
  }

  getBreadCrumbMenu(base:string, routes:string[]):string[] {
    const currentRoutes = routes[0] === base ? routes : [base, ...routes];
    const breadCrumbMenu: string[] = [];
    let menuCopy = structuredClone(this.menu);
    for (const route of currentRoutes) {
      const menuItem = menuCopy.find(m=>m.route === route) || null;
      if(menuItem){
        breadCrumbMenu.push(menuItem.value);
        if(menuItem.child?.length){
          menuCopy = menuItem.child;
        }else{
          break;
        }
      }
    }
    return breadCrumbMenu;
  }
}
